import en from './en.json';
import de from './de.json';

const settingsLocales = {
  en,
  de,
};

export default settingsLocales;
